import type { GeneratedColumn } from "building-types/columns/columnGeneratedTypes";
import type { BuildingGeometryEmitter } from "building-types/geometry/buildingGeometryTypes";
import { roomEntityHandleForSelectingReportingUnit } from "building-types/handles/roomEntityHandleForSelectingReportingUnit";
import type { ExteriorPalette } from "building-types/materials/exteriorPaletteTypes";
import { FaceCategory } from "building-types/materials/faceCategories";
import type { Room } from "building-types/rooms/roomTypes";
import type { Table } from "common/data/table";
import { materialSrcFromPalette } from "doc/materialLookup";
import { extrusionToBRep } from "geom/extrude";
import { UVGeneration } from "geom/uv";
import { buildExteriorLayers } from "./buildingGeometryTools";

export function getColumnGeometries(
  columns: Table<GeneratedColumn>,
  rooms: Table<Room>,
  exteriorPalette: ExteriorPalette,
  emitter: BuildingGeometryEmitter,
): void {
  for (const columnId in columns) {
    const column = columns[columnId];
    const { extrusions, paletteId, levelId, pickHandle, roomId } = column;
    const entityHandleForSelectingReportingUnit = roomEntityHandleForSelectingReportingUnit(rooms[roomId]);
    for (const ext of extrusions) {
      emitter.emit({
        geom: extrusionToBRep(ext),
        materialSlot: undefined,
        materialSrc: materialSrcFromPalette(exteriorPalette, paletteId),
        faceCategory: FaceCategory.COLUMN,
        uvGen: UVGeneration.GLOBAL_RECT_UV,
        threeLayers: buildExteriorLayers(),
        levelId,
        pickHandle,
        entityHandleForSelectingReportingUnit,
      });
    }
  }
}
